import React, { useState } from 'react';
import getUsersFromPresence from './getUsersFromPresence';
import * as styles from './Presence.module.scss';
import PresenceAvatarStack from './PresenceAvatarStack';
import PresencePopOver from './PresencePopOver';
import useAppSelector from '../app/redux/useAppSelector';
import Button from '../components/Button';
import FloatingCard from '../components/FloatingCard';
import HoverView from '../components/HoverView';
import type { PresenceState } from '../editor/editorSlice';
import teamIcon from '../icons/non-prefilled/16x16/team.svg';
import addTestId from '../utils/addTestId';

const MAX_VISIBLE_COUNT = 6;

const isEditing = (meta: PresenceState['metas'][number]) => meta.edit;

const Presence = () => {
  const [isHoverViewOpen, setIsHoverViewOpen] = useState(false);

  const presence = useAppSelector((state) => state.editor.presence);
  const currentUser = useAppSelector((state) => state.session.user);

  const sortedPresence = Object.values(presence).toSorted(
    (a, b) => a.user.index - b.user.index,
  );

  const allUsers = getUsersFromPresence(sortedPresence);

  const usersToShow = allUsers.filter(
    (user) =>
      user.user.id !== currentUser.id ||
      (presence?.[user?.user?.id]?.metas.filter(isEditing).length ?? 0) > 1,
  );
  if (!usersToShow.length) return null;

  const visibleCount =
    usersToShow.length > MAX_VISIBLE_COUNT
      ? MAX_VISIBLE_COUNT - 1 // 1 for the counter
      : usersToShow.length;

  const stackOrder = ['editing', 'reading', 'inactive'];

  return (
    <HoverView
      view={
        <FloatingCard noArrow>
          <PresencePopOver users={allUsers} />
        </FloatingCard>
      }
      hoverDelay="fast"
      open={isHoverViewOpen}
      onOpenChange={setIsHoverViewOpen}
    >
      <div>
        <div {...addTestId('presenceContainer')} className={styles.presence}>
          <div className={styles.avatar}>
            <PresenceAvatarStack
              users={usersToShow
                .toSorted(
                  ({ status: a }, { status: b }) =>
                    stackOrder.indexOf(a) - stackOrder.indexOf(b),
                )
                .slice(0, visibleCount)}
            />
          </div>
          {usersToShow.length - visibleCount > 0 && (
            <span className={styles.counter}>
              {usersToShow.length - visibleCount}
            </span>
          )}
        </div>
        <div className={styles.presenceCompact}>
          <Button
            icon={teamIcon}
            onClick={() => setIsHoverViewOpen(!isHoverViewOpen)}
          >
            {usersToShow.length}
          </Button>
        </div>
      </div>
    </HoverView>
  );
};

export default Presence;
